import * as React from "react";

const SvgIcon = ({ size = '36', color = '#f9a928' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    viewBox="0 0 47 36"
  >
    <path
      fill={color}
      d="M4.173 32.897C1.458 30.017 0 26.787 0 21.552 0 12.34 6.476 4.082 15.894 0l2.354 3.627c-8.79 4.749-10.51 10.91-11.194 14.796 1.415-.732 3.268-.988 5.084-.82 4.755.44 8.503 4.339 8.503 9.185a9.2 9.2 0 0 1-2.702 6.514A9.23 9.23 0 0 1 11.416 36a10.22 10.22 0 0 1-7.243-3.103m26.358 0c-2.715-2.88-4.172-6.11-4.172-11.345 0-9.212 6.476-17.47 15.894-21.552l2.354 3.627c-8.79 4.749-10.51 10.91-11.195 14.796 1.416-.732 3.269-.988 5.085-.82 4.755.44 8.503 4.339 8.503 9.185a9.2 9.2 0 0 1-2.702 6.514A9.23 9.23 0 0 1 37.775 36a10.22 10.22 0 0 1-7.244-3.103"
    ></path>
  </svg>
);

export default SvgIcon;
